import { render, staticRenderFns } from "./ErrorDisplay.vue?vue&type=template&id=31ddf096&"
import script from "./ErrorDisplay.vue?vue&type=script&lang=js&"
export * from "./ErrorDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports